import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useAuth } from '../../auth/services/authService';
import { checkSellerByUserId } from '../../auth/services/firestoreService';

const MainLayout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [shopName, setShopName] = useState('Dashboard');
  const [shopLogo, setShopLogo] = useState(null);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const fetchShopData = async () => {
      if (user) {
        try {
          const { seller, error: _error } = await checkSellerByUserId(user.uid);
          if (seller) {
            if (seller.shopName) setShopName(seller.shopName);
            setShopLogo(seller.profileImage || seller.shopImage || seller.photoURL || null);
          }
        } catch (err) {
          console.error("Error fetching shop data:", err);
        }
      }
    };

    fetchShopData();
  }, [user]);

  // Theme Toggle state
  const [theme, setTheme] = useState(localStorage.getItem('seller_portal_theme') || 'dark');

  useEffect(() => {
    const isLight = theme === 'cream' || theme === 'light' || theme === 'theme-cream' || theme === 'theme-light';
    if (isLight) {
      document.body.classList.add('theme-cream', 'theme-light', 'light');
      document.documentElement.classList.add('theme-cream', 'theme-light', 'light');
    } else {
      document.body.classList.remove('theme-cream', 'theme-light', 'light');
      document.documentElement.classList.remove('theme-cream', 'theme-light', 'light');
    }
    localStorage.setItem('seller_portal_theme', theme);
  }, [theme]);

  // Route transition effect
  useEffect(() => {
    setTransitioning(true);
    const timer = setTimeout(() => {
      setTransitioning(false);
    }, 400); // Fades out after 400ms
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const isLight = theme === 'cream' || theme === 'light' || theme === 'theme-cream' || theme === 'theme-light';

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isLight ? 'bg-[#faf6ee] text-[#2b251f]' : 'bg-[#06070a] text-white'} selection:bg-[#FF0057]/20`}>
      {/* Top Loading Progress Bar */}
      {transitioning && (
        <div className="fixed top-0 left-0 right-0 h-[3px] z-[9999] pointer-events-none">
          <style>{`
            @keyframes load-progress {
              0% { width: 0%; opacity: 1; }
              90% { width: 90%; opacity: 1; }
              100% { width: 100%; opacity: 0; }
            }
            .animate-progress {
              animation: load-progress 0.4s cubic-bezier(0.1, 0.8, 0.3, 1) forwards;
            }
          `}</style>
          <div className="h-full bg-gradient-to-r from-[#fe2c55] via-[#ff4d6a] to-[#25f4ee] shadow-[0_0_8px_rgba(254,44,85,0.4)] animate-progress"></div>
        </div>
      )}
      
      <Sidebar />
      <Topbar title={shopName} logo={shopLogo} theme={theme} setTheme={setTheme} />
      
      {/* Main Content Wrapper */}
      <main className="md:ml-64 pt-16 min-h-screen pb-20 md:pb-0 transition-all duration-300">
        <div className="p-4 md:p-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
